import {
  Box,
  Icon,
  Text,
  Tooltip,
  Touchable,
  useToggle,
} from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  currentFileIndex: number
  totalFiles: number
  pendingStampsToPlace: boolean[]
  showValidations: boolean
  onClickPrev: () => void
  onClickNext: () => void
}

const FilesBrowser = ({
  currentFileIndex,
  totalFiles,
  pendingStampsToPlace,
  showValidations,
  onClickPrev,
  onClickNext,
}: Props) => {
  const hasFilePendingStamps = !!pendingStampsToPlace[currentFileIndex]
  const filesWithPendingStamps = pendingStampsToPlace.some((file) => file)
  const openError = !hasFilePendingStamps && filesWithPendingStamps
  const [openWarning, toggleWarning] = useToggle(false)
  const isFirstFile = currentFileIndex === 0
  const isLastFile = currentFileIndex === totalFiles - 1
  const enabledChevron = 'grey600'
  const disabledChevron = 'grey400'

  return (
    <Box
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      paddingY="s12"
      paddingX="s16"
      height="s64"
      gap="s8"
      border={{ bottom: { width: 's2', style: 'solid', color: 'grey200' } }}
    >
      <Touchable
        onClick={onClickPrev}
        disabled={isFirstFile}
        title={i18n.t('common.pagination.previous')}
        aria-label={i18n.t('common.pagination.previous')}
      >
        <Icon.Small icon="chevron-left" color={isFirstFile ? disabledChevron : enabledChevron} />
      </Touchable>
      <Box alignItems="center" justifyContent="center">
        <Text size="200" color="grey800" weight="semibold">
          {i18n.t('split_documents.header.file_of', {
            current: currentFileIndex + 1,
            total: totalFiles,
          })}
        </Text>
      </Box>
      {filesWithPendingStamps && !showValidations && (
        <Tooltip.Alt
          attachment="top center"
          label={i18n.t('documents.beta.esignature_placement.pending_stamps')}
          textAlign="center"
          toggle={toggleWarning}
          open={openWarning}
        >
          <Icon.Medium icon="alert-circle" color="darker800" />
        </Tooltip.Alt>
      )}
      {filesWithPendingStamps && showValidations && (
        <Tooltip.Alt
          attachment="top center"
          label={i18n.t('documents.beta.esignature_placement.pending_stamps_error')}
          textAlign="center"
          open={openError}
        >
          <Icon.Medium icon="alert-circle" color="radicalRed1000" />
        </Tooltip.Alt>
      )}
      <Touchable
        onClick={onClickNext}
        disabled={isLastFile}
        title={i18n.t('common.pagination.next')}
        aria-label={i18n.t('common.pagination.next')}
      >
        <Icon.Small icon="chevron-right" color={isLastFile ? disabledChevron : enabledChevron} />
      </Touchable>
    </Box>
  )
}

export default FilesBrowser
